<div class="modal-header confirm">
    <h2 class="modal-title">Top Up Float</h2>
    <button (click)="dismiss()" aria-label="Close" class="reset-width close" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    @let result = (floatReference$ | async);

    @if (result == null) {
        <p class="top-up-loading">Loading your float reference…</p>
    } @else if (result.reference == null) {
        <div class="alert alert-warning top-up-reference-unavailable" role="alert">
            Your float reference is currently unavailable. Please try again later or contact support.
        </div>
    } @else {
        <p>Ready to top up your float? Simply make a payment using the details below:</p>

        <dl class="top-up-details">
            <dt>Bank</dt>
            <dd class="top-up-bank-name">{{ bankDetails.bankName }}</dd>
            <dt>Account Number</dt>
            <dd class="top-up-account-number">{{ bankDetails.accountNumber }}</dd>
            <dt>Branch Code</dt>
            <dd class="top-up-branch-code">{{ bankDetails.branchCode }}</dd>
            <dt>Reference</dt>
            <dd class="top-up-reference">{{ result.reference }}</dd>
        </dl>
    }
</div>

<div class="modal-footer">
    <button (click)="dismiss()" class="btn btn-dark" type="button">Close</button>
</div>
